'use strict';

const workerUtils = require('./workerUtils');
const scriptsValidator = require('./scriptsValidator');
const scriptRunner = require('./scriptRunner');

function getEmptyModule() {
  return {};
}

function loadScripts(scripts, userCodeStore) {
  const appId = 'wixCode';
  const devConsole = console; // eslint-disable-line no-console
  scripts
    .filter(script => !userCodeStore.get(script.url))
    .forEach(script => {
      try {
        var moduleFunc = workerUtils.importScriptsAsAmdModule(self, script.url, appId, script.displayName);
        userCodeStore.set(script.url, scriptRunner.runScript.bind(this, devConsole, appId, script, moduleFunc));
      } catch (e) {
        devConsole.error('There was an error in your script');
        devConsole.error(e);
        userCodeStore.set(script.url, getEmptyModule);
      }
    });
}

function handleLoadUserCode({wixCode} = {}, {userCodeStore}) {
  if (wixCode && wixCode[0] && wixCode[0].routerData) {
    self.routerData = wixCode[0].routerData;
  }
  scriptsValidator.validate(wixCode, ['id', 'url', 'scriptName', 'displayName']);

  loadScripts(wixCode, userCodeStore);
}

module.exports = {
  handleLoadUserCode: handleLoadUserCode
};



// WEBPACK FOOTER //
// ./src/main/worker/loadUserCodeHandler.js